
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabaerviceinchakanmidc() {



    const cardData =
    {
        keyword: 'Cab Service in Chakan MIDC',
        heading: 'Platinum24 Cabs: Cab Service in Chakan MIDC',
        headingDescription: ' Platinum24 Cabs provides professional Cab Service in Chakan MIDC, specially designed for industrial employees, corporate travelers, and business visitors. With a fleet of hatchbacks, sedans, SUVs, and luxury cars, we ensure safe and reliable transportation within the busy Chakan MIDC area and to nearby cities. Our services include daily staff transport, airport transfers, outstation cabs, and corporate travel solutions at affordable rates. Backed by experienced drivers, punctual service, and clean vehicles, Platinum24 Cabs guarantees smooth, comfortable, and stress-free travel for employees and executives across Chakan MIDC.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort palace. Once the seat of the Maratha Empire, it witnessed the glory of Bajirao and Mastani. The grand gates, fountains, and gardens still narrate Maratha history. Though partially destroyed by fire in 1828, it remains a heritage symbol. The evening light-and-sound show revives tales of bravery. Shaniwar Wada is Pune’s proud cultural landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is associated with India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. The palace now houses a museum with Gandhi’s belongings and photographs. Its sprawling lawns and Italian arches make it architecturally elegant. It is also the resting place of Kasturba Gandhi. Aga Khan Palace is Pune’s historic inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, 25 km from Pune, is famous for the 1670 battle fought by Tanaji Malusare for Chhatrapati Shivaji Maharaj. Located atop a hill, it offers trekking trails and Sahyadri valley views. Visitors explore bastions, temples, and memorials of Maratha bravery. Monsoon adds mist and waterfalls to the experience. Local villagers serve authentic pithla-bhakri meals at the summit. Sinhagad is Pune’s heritage adventure spot."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine of Lord Ganesha. The grand idol is richly adorned with gold and ornaments. During Ganesh Chaturthi, the temple becomes the epicenter of massive festivities. It is also known for its charitable and cultural works. Devotees from across India visit for blessings. Dagdusheth Temple is Pune’s spiritual and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. It features massive stone pillars, a sanctum, and a Nandi mandapa. Despite being in the city center, it provides a peaceful retreat. Evening prayers add to its mystical charm. The carvings reflect ancient Indian craftsmanship. Pataleshwar is Pune’s hidden spiritual gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include ornaments, musical instruments, sculptures, and antiques of daily use. The recreated Mastani Mahal is a major highlight. Students and history lovers find it educational and fascinating. It preserves centuries of Indian tradition and culture. This museum is Pune’s proud showcase of art and heritage."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest heritage sites, offering panoramic views of the city. At the hilltop stands the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the temple, blending devotion with adventure. Smaller shrines and a museum add cultural depth. Sunrises and sunsets here are breathtaking. Parvati Hill is Pune’s sacred scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global wellness and spirituality hub. Spread across serene gardens, it offers meditation, yoga, and growth workshops. Zen-inspired landscapes and modern facilities attract seekers from around the world. Visitors experience peace, rejuvenation, and mindfulness. It blends spirituality with a modern lifestyle. Osho Ashram is Pune’s international retreat of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and lush green lawns. Families and couples enjoy picnics, nature walks, and photography here. Seasonal flowers and manicured gardens add to its charm. It also symbolizes Indo-Japanese cultural friendship. Pu La Deshpande Garden is Pune’s peaceful green paradise."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a favorite weekend spot near Pune. It provides water to the city while offering scenic views of hills and flowing waters. Monsoon transforms it into a breathtaking picnic destination. Vendors selling hot corn and tea enhance the experience. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s natural retreat of refreshment."
  }
],


        "services": [
    {
      "name": "Chakan MIDC Cab Service",
      "description": "Our Chakan MIDC Cab Service provides reliable and on-time transportation for employees, professionals, and visitors in the industrial hub of Chakan MIDC. Whether you're commuting to work, visiting a factory, or managing logistics meetings, our cabs ensure safe and comfortable rides. With a variety of vehicle options and highly trained drivers, we specialize in daily office drops, multi-shift operations, and client transfers with professionalism and punctuality. Book your cab easily through our 24x7 helpline or online platform and travel stress-free in and around Chakan MIDC."
    },
    {
      "name": "Taxi Service Chakan MIDC",
      "description": "Get around Chakan MIDC efficiently with our dedicated Taxi Service Chakan MIDC. Designed for workers, executives, and guests visiting industrial plants, our service includes clean, well-maintained vehicles and experienced drivers familiar with the area. Whether it’s a pickup from Pune city, a drop to the airport, or intra-MIDC travel, we guarantee timely service and transparent fares. Choose from hatchbacks, sedans, and SUVs for a smooth and convenient ride every time."
    },
    {
      "name": "Chakan MIDC Local Taxi",
      "description": "Need quick and affordable transport within the Chakan MIDC area? Our Chakan MIDC Local Taxi service offers convenient travel across factories, office zones, hotels, and residential sectors. With short-wait times and professional drivers who know the industrial layout well, we help you move swiftly between meetings, sites, or shift changes. Perfect for both one-time use and regular commutes, with competitive hourly packages also available."
    },
    {
      "name": "Affordable Taxi Chakan MIDC",
      "description": "Enjoy budget-friendly transportation without compromising on quality with our Affordable Taxi Chakan MIDC service. Ideal for factory workers, contract staff, and budget-conscious professionals, our fleet includes fuel-efficient vehicles with low fares and zero hidden charges. Whether it's a short ride across the MIDC area or a day-long rental, we offer the most economical and reliable taxi solution in the region."
    },
    {
      "name": "Chakan MIDC Taxi with Driver",
      "description": "Our Chakan MIDC Taxi with Driver service ensures you can focus on your work while we handle the roads. Our drivers are background-verified, trained in corporate etiquette, and well-acquainted with Chakan's routes and industrial layouts. Ideal for factory visits, executive travel, or vendor meetings, this service offers safety, professionalism, and comfort, every step of the way. Choose from hourly or full-day driver-included packages."
    },
    {
      "name": "Chakan MIDC Airport Taxi",
      "description": "Travel to and from Pune Airport conveniently with our Chakan MIDC Airport Taxi service. We offer 24x7 airport transfers, tracking flight schedules in real-time to ensure timely pickups and drop-offs. Whether you're flying in for a plant visit or heading home after work, our taxis are always ready. Enjoy spacious vehicles, courteous drivers, and competitive fixed pricing for a smooth, hassle-free airport commute."
    },
    {
      "name": "Cab Rental Chakan MIDC",
      "description": "Our Cab Rental Chakan MIDC service is designed for industrial professionals, visitors, and executives who need a flexible mobility solution. Rent a cab for a few hours, a full day, or long-term use — with or without a driver. Choose from compact cars to executive sedans and SUVs, all fully sanitized and well-maintained. Perfect for plant tours, staff travel, and corporate delegations with transparent billing and tailored rental packages."
    },
    {
      "name": "Chakan MIDC Outstation Taxi",
      "description": "Planning a trip from Chakan MIDC to Pune, Mumbai, Nashik, or nearby locations? Our Chakan MIDC Outstation Taxi service is perfect for long-distance travel. Choose from one-way or round-trip options, all handled by experienced drivers and fully serviced vehicles. With all-inclusive packages, toll coverage, and customer support throughout your journey, we make intercity travel reliable and safe for both business and personal needs."
    },
    {
      "name": "Chakan MIDC Corporate Taxi",
      "description": "Our Chakan MIDC Corporate Taxi service is built for businesses operating in the industrial belt. We provide corporate car rental plans for employee shuttles, visitor pickups, and VIP transfers. Benefit from monthly billing, GST invoices, priority bookings, and fleet customization. All our drivers are trained in professional conduct, and our vehicles are GPS-enabled and maintained for corporate standards. Improve your company’s travel efficiency with our tailored taxi solutions."
    },
    {
      "name": "Chakan MIDC Taxi Deals",
      "description": "Maximize your savings with exclusive Chakan MIDC Taxi Deals. We offer attractive discounts on daily commutes, long-term rentals, airport transfers, and group bookings. Special rates available for regular users and bulk corporate bookings. Our deals are available through both online and phone bookings and are updated frequently to help you save more on every trip in and out of Chakan MIDC."
    },
    {
      "name": "Chakan MIDC Family Taxi Service",
      "description": "Visiting Chakan MIDC with your family? Our Chakan MIDC Family Taxi Service offers spacious vehicles and safety-focused travel ideal for group or family visits. Whether you’re traveling for a weekend stay or attending an event, our drivers ensure a smooth and relaxed journey. Child seats, luggage-friendly cars, and extra comfort options available on request to make your family travel easy and secure."
    },
    {
      "name": "Taxi Booking Online Chakan MIDC",
      "description": "Book your cab in minutes with Taxi Booking Online Chakan MIDC. Our online platform offers real-time vehicle availability, instant confirmation, flexible scheduling, and multiple payment options. You can choose your vehicle, track your driver, and manage bookings from your phone or laptop. Whether it's a last-minute ride or a planned business trip, booking your taxi online has never been easier or more secure."
    },
    {
      "name": "Chakan MIDC Taxi Service 24x7",
      "description": "Working late shifts or traveling early? Our Chakan MIDC Taxi Service 24x7 is always available, day or night. Designed for the 24-hour nature of industrial operations, this service provides round-the-clock transportation for factory workers, managers, and emergency logistics. With a reliable fleet, alert drivers, and responsive support, we’re here to meet your travel needs anytime you call."
    }
  ],
  "tableData": [
    ["Chakan MIDC Cab Service", "Taxi Service Chakan MIDC"],
    ["Chakan MIDC Local Taxi", "Affordable Taxi Chakan MIDC"],
    ["Chakan MIDC Taxi with Driver", "Chakan MIDC Airport Taxi"],
    ["Cab Rental Chakan MIDC", "Chakan MIDC Outstation Taxi"],
    ["Chakan MIDC Corporate Taxi", "Chakan MIDC Taxi Deals"],
    ["Chakan MIDC Family Taxi Service", "Taxi Booking Online Chakan MIDC"],
    ["Chakan MIDC Taxi Service 24x7", "—"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Trusted Cab Service in Chakan MIDC",
    "WhyChoosedescription": "Platinum24 Cabs offers reliable and affordable cab services in Chakan MIDC for all your industrial and personal travel needs."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles to Suit Your Requirements",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and tempo travellers tailored for group size and comfort."
  },
  {
    "WhyChooseheading": "Clean and Sanitized Cabs for Safe Travel",
    "WhyChoosedescription": "All vehicles are regularly cleaned and sanitized to ensure a hygienic and comfortable ride in Chakan MIDC."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Chakan MIDC Routes",
    "WhyChoosedescription": "Professional drivers with in-depth knowledge of Chakan MIDC ensure timely and smooth travel."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Enjoy competitive fares that include fuel, tolls, and driver allowances with no hidden charges."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with your cab bookings in Chakan MIDC."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages for Short and Long Term",
    "WhyChoosedescription": "Choose hourly, daily, or long-term rental plans designed to fit your travel schedule."
  },
  {
    "WhyChooseheading": "Quick and Easy Online Booking with Instant Confirmation",
    "WhyChoosedescription": "Book your Chakan MIDC cab quickly and securely through our website or app with real-time confirmation."
  }
]


















    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer cab services in Chakan MIDC?',
        answer: 'Yes, Platinum24 Cabs offers reliable and professional cab services in Chakan MIDC for employees, business visitors, and local travel.',
    },
    {
        question: 'How can I book a cab in Chakan MIDC with Platinum24 Cabs?',
        answer: 'You can easily book a cab through our website, mobile app, or by contacting our 24x7 customer support.',
    },
    {
        question: 'What types of vehicles are available for cab service in Chakan MIDC?',
        answer: 'We provide hatchbacks, sedans, SUVs, and even tempo travellers for individual and group travel in Chakan MIDC.',
    },
    {
        question: 'Do you offer corporate cab services in Chakan MIDC?',
        answer: 'Yes, we specialize in corporate and industrial transportation solutions for companies operating in Chakan MIDC.',
    },
    {
        question: 'Are the drivers experienced and familiar with Chakan MIDC routes?',
        answer: 'Absolutely, our drivers are trained, professional, and well-acquainted with the Chakan MIDC area and nearby routes.',
    },
    {
        question: 'Is daily and monthly cab rental available in Chakan MIDC?',
        answer: 'Yes, we offer flexible daily, weekly, and monthly cab rental packages for employees and companies in Chakan MIDC.',
    },
    {
        question: 'Are the cabs in Chakan MIDC sanitized and safe?',
        answer: 'Yes, all our vehicles are regularly sanitized and follow strict hygiene and safety standards.',
    },
    {
        question: 'Is cab service in Chakan MIDC available 24x7?',
        answer: 'Yes, Platinum24 Cabs provides round-the-clock cab services in and around Chakan MIDC.',
    },
    {
        question: 'What payment options are accepted for cab bookings in Chakan MIDC?',
        answer: 'We accept UPI, digital wallets, credit/debit cards, and cash for all bookings.',
    },
    {
        question: 'Can I customize pickup and drop-off points within Chakan MIDC?',
        answer: 'Yes, you can specify your desired pickup and drop-off locations within Chakan MIDC and surrounding areas.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Anil More',
        feedback: 'Platinum24 Cabs offers the best cab service in Chakan MIDC. Timely pickups and well-maintained vehicles.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Sonali Pawar',
        feedback: 'Used Platinum24 Cabs for daily commute to Chakan MIDC. Safe, clean, and reliable service every time.',
        rating: 5,
    },
];










































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const chakanMIDCCabServiceSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Trusted and affordable cab service in Chakan MIDC offering local taxi, airport transfers, outstation cabs, corporate taxi, and family taxi services with driver, available 24x7.",
  "areaServed": {
    "@type": "Place",
    "name": "Chakan MIDC, Pune"
  },
  "serviceType": [
    "Chakan MIDC Cab Service",
    "Taxi Service Chakan MIDC",
    "Chakan MIDC Local Taxi",
    "Affordable Taxi Chakan MIDC",
    "Chakan MIDC Taxi with Driver",
    "Chakan MIDC Airport Taxi",
    "Cab Rental Chakan MIDC",
    "Chakan MIDC Outstation Taxi",
    "Chakan MIDC Corporate Taxi",
    "Chakan MIDC Taxi Deals",
    "Chakan MIDC Family Taxi Service",
    "Taxi Booking Online Chakan MIDC",
    "Chakan MIDC Taxi Service 24x7"
  ],
  "telephone": "+91-XXXXXXXXXX"
};






    return (
        <div>
<Helmet>
  <title>Cab Service in Chakan MIDC | Affordable Taxi Service Chakan MIDC Pune</title>
  <meta
    name="description"
    content="Trusted and affordable cab service in Chakan MIDC offering local taxi, airport transfers, outstation cabs, corporate taxi, and family taxi services with driver, available 24x7."
  />
  <meta
    name="keywords"
    content="Chakan MIDC Cab Service, Taxi Service Chakan MIDC, Chakan MIDC Local Taxi, Affordable Taxi Chakan MIDC, Chakan MIDC Taxi with Driver, Chakan MIDC Airport Taxi, Cab Rental Chakan MIDC, Chakan MIDC Outstation Taxi, Chakan MIDC Corporate Taxi, Chakan MIDC Taxi Deals, Chakan MIDC Family Taxi Service, Taxi Booking Online Chakan MIDC, Chakan MIDC Taxi Service 24x7"
  />
  <script type="application/ld+json">
    {JSON.stringify(chakanMIDCCabServiceSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/90.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabaerviceinchakanmidc;